/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import type { IconSize } from 'bundles/ai-coach-platform/types';

type Props = {
  size?: IconSize;
  fill?: string;
};

/**
 * MUI icon for recording stop
 */
const StopIcon = ({ size = 16, fill = 'inherit' }: Props) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    width={size}
    viewBox="0 -960 960 960"
    fill={fill}
  >
    <path d="M240-320v-320q0-33 23.5-56.5T320-720h320q33 0 56.5 23.5T720-640v320q0 33-23.5 56.5T640-240H320q-33 0-56.5-23.5T240-320Zm80 0h320v-320H320v320Zm160-160Z" />
  </svg>
);

export default StopIcon;
